"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAmount = void 0;
var format_decimal_1 = require("./format-decimal");
var getAmount = function (value, fractionDigits, suffix, nullValue, positivePrefix) {
    if (positivePrefix === void 0) { positivePrefix = false; }
    var abs = Math.abs(value);
    var factor = Math.pow(10, fractionDigits);
    var threshold = 1 / factor;
    if (value !== 0 && abs < threshold) {
        var formattedThreshold = (0, format_decimal_1.formatDecimal)(threshold, fractionDigits);
        if (value > 0) {
            return "<".concat(formattedThreshold, " ").concat(suffix);
        }
        return ">-".concat(formattedThreshold, " ").concat(suffix);
    }
    if (value === 0 && nullValue === undefined) {
        return '—';
    }
    if (suffix === '%') {
        return "".concat(positivePrefix && value > 0 ? '+' : '').concat((0, format_decimal_1.formatDecimal)(value, fractionDigits), "%");
    }
    return "".concat(positivePrefix && value > 0 ? '+' : '').concat((0, format_decimal_1.formatDecimal)(value, fractionDigits), " ").concat(suffix);
};
exports.getAmount = getAmount;
//# sourceMappingURL=get-amount.js.map